import React from 'react'
import ReportStandardUserListMobileTab from './ReportStandardUserListMobileTab'
import { buildReportOrdersUserMobileCardSections } from './reportOrdersUserMobileCardModel'

export default function ReportOrdersMobileTab(props) {
  return (
    <ReportStandardUserListMobileTab {...props} buildCardSections={buildReportOrdersUserMobileCardSections} />
  )
}
